import React from 'react';

const Footer = () => {
	return 	<div id="footer-wrap">
		<div className="container">
			<div className="row">
				<div className="col-md-2 col-sm-4 col-xs-6">
					<ul className="list-unstyled">
						<li><a href="https://global.medical.canon/products">Products</a></li>
						<li><a href="https://global.medical.canon/products/Index">View All Products</a></li>
						<li><a href="https://global.medical.canon/products/angiography">Angiography</a></li>
						<li><a href="https://global.medical.canon/products/computed-tomography">Computed Tomography</a></li>
						<li><a href="https://global.medical.canon/products/magnetic-resonance">Magnetic Resonance</a></li>
						<li><a href="https://global.medical.canon/products/ultrasound">Ultrasound</a></li>
						<li><a href="https://global.medical.canon/products/xray">X-Ray</a></li>
						<li><a href="https://global.medical.canon/products/nuclear_medicine">Nuclear Medicine</a></li>
						<li><a href="https://global.medical.canon/products/healthcare_it">Healthcare IT</a></li>
						<li><a href="https://global.medical.canon/products/RF_AC">RF Amplifier Components</a></li>
					</ul>
				</div>
				<div className="col-md-2 col-sm-4 col-xs-6">
					<ul className="list-unstyled">
						<li><a href="https://global.medical.canon/service-support">Service &amp; Support</a></li>
						<li><a href="https://global.medical.canon/service-support/service">Service</a></li>
						<li><a href="https://global.medical.canon/service-support/Interoperability">Interoperability (DICOM/IHE)</a></li>
						<li><a href="https://global.medical.canon/service-support/support">Support</a></li>
						<li><a href="https://global.medical.canon/service-support/securityinformation">Product Security Information</a></li>
					</ul>
				</div>
				<div className="col-md-2 col-sm-4 col-xs-6">
					<ul className="list-unstyled">
						<li><a href="https://global.medical.canon/publication">Publication</a></li>
						<li><a href="https://global.medical.canon/publication/index">Publication</a></li>
					</ul>
				</div>
				<div className="col-md-2 col-sm-4 col-xs-6">
					<ul className="list-unstyled">
						<li><a href="https://global.medical.canon/News">News &amp; Events</a></li>
						<li><a href="https://global.medical.canon/News/events">Events</a></li>
						<li><a href="https://global.medical.canon/News/PressRelease">Press Release</a></li>
					</ul>
				</div>
				<div className="col-md-2 col-sm-4 col-xs-6">
					<ul className="list-unstyled">
						<li><a href="https://global.medical.canon/about">About Us</a></li>
						<li><a href="https://global.medical.canon/about/index">President’s Message</a></li>
						<li><a href="https://global.medical.canon/about/corporate">Corporate Profile</a></li>
						<li><a href="https://global.medical.canon/about/global">Global Network</a></li>
						<li><a href="https://global.medical.canon/about/environment">Environmental Activities</a></li>
						<li><a href="https://global.medical.canon/about/medicalAR">medicalAR</a></li>
					</ul>
				</div>
				<div className="col-md-2 col-sm-4 col-xs-6">
					<ul className="list-unstyled">
						<li><a href="https://global.medical.canon/contact">Contact Us</a></li>
						<li><a href="https://global.medical.canon/contact/index">Contact Us</a></li>
						<li><a href="https://global.medical.canon/contact/inquiry">Inquiry form</a></li>
					</ul>
				</div>
			</div>
			<div className="row" id="footer-company-info">
				
				<div className="row col-sm-12" style={{ paddingBottom: '3em', paddingLeft: '2em'}}>
					Due to medical device regulatory reasons, not all products/service displayed on this Canon Medical Systems global webpage are available in all countries, regions or markets. Future availability of the products/service cannot also be guaranteed. Please contact your local Canon Medical Systems representative for further details.
				</div>

				<div className="col-lg-6 col-md-6 col-sm-6" prefix="s: http://www.sdl.com/web/schemas/core" typeof="s:DeepFooter">
					<div className="visible-sm visible-md visible-lg">
						{/*<span>
							<img src="/media/e_CANON_medsys_ol_tcm19-18427.jpg" width="300" className="img-responsive"/>
						</span>*/}
						<p className="footer-legal">
							<small>
							<a href="https://global.medical.canon/terms_conditions"> Terms and Conditions  </a>
							<a href="https://global.medical.canon/privacy">|  Privacy Policy  </a>
							<a href="https://global.medical.canon/sitemap.html">|  Site Map  </a>
							</small>
						</p>
					</div>
					<div className="visible-xs text-center">
						{/*<span>
							<img src="/media/e_CANON_medsys_ol_tcm19-18427.jpg" width="300" className="img-responsive center-block"/>
						</span>*/}
						<p className="footer-legal">
							<small>
								<a href="https://global.medical.canon/terms_conditions"> Terms and Conditions  </a>
								<a href="https://global.medical.canon/privacy">|  Privacy Policy  </a>
								<a href="https://global.medical.canon/sitemap.html">|  Site Map  </a>
							</small>
						</p>
					</div>
				</div>
				<div className="col-lg-6 col-md-6 col-sm-6" prefix="s: http://www.sdl.com/web/schemas/core" typeof="s:DeepFooter">
					<p className="text-right visible-sm visible-md visible-lg">
						<small>
						<span>
							© CANON MEDICAL SYSTEMS CORPORATION
						</span>
						<span>
						</span>
						</small>
					</p>
					<p className="text-center visible-xs">
						<small>
						<span>
							© CANON MEDICAL SYSTEMS CORPORATION
						</span>
						<span>
						</span>
						</small>
					</p>
				</div>
			</div>
		</div>
	</div>
}

export default Footer;


// WEBPACK FOOTER //
// ./src/blocks/footer/footer.jsx